import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M28.4 33.1V11.7H16.6v21.4H0V45h45V33.1H28.4zm-9.3-18.9h6.8V33h-6.8V14.2zm23.4 28.3h-40v-6.9h40v6.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M16.6 33.1h-12l12-12v12zm-5.9-2.5H14v-3.3l-3.3 3.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M40.4 33.1h-12v-12l12 12zm-9.5-2.5h3.3l-3.3-3.3v3.3z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M8.5 11.7H6C6 5.3 11.3 0 17.7 0v2.5c-5 0-9.2 4.1-9.2 9.2z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M14 11.7h-2.5c0-3.5 2.8-6.3 6.3-6.3v2.5c-2.2 0-3.8 1.7-3.8 3.8z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M39 11.7h-2.5c0-5.1-4.1-9.2-9.2-9.2V0C33.7 0 39 5.3 39 11.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M33.5 11.7H31c0-2.1-1.7-3.8-3.8-3.8V5.4c3.5 0 6.3 2.8 6.3 6.3z"
			})
		] })
	]
});
export default SvgIcon;
